import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "calendar" }
const _hoisted_2 = {
  key: 1,
  class: "change-month"
}
const _hoisted_3 = {
  key: 0,
  class: "current-month"
}
const _hoisted_4 = { class: "calendar-table" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"t-head\"><div class=\"tr week-day\"><div class=\"td weekend\">日</div><div class=\"td\">一</div><div class=\"td\">二</div><div class=\"td\">三</div><div class=\"td\">四</div><div class=\"td\">五</div><div class=\"td weekend\">六</div></div></div>", 1)
const _hoisted_6 = { class: "prev" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "date-num" }
const _hoisted_9 = {
  key: 0,
  class: "date-lunar"
}
const _hoisted_10 = { class: "t-body current" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "date-num" }
const _hoisted_13 = {
  key: 0,
  class: "date-lunar"
}
const _hoisted_14 = { class: "next" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "date-num" }
const _hoisted_17 = {
  key: 0,
  class: "date-lunar"
}
const _hoisted_18 = {
  key: 1,
  class: "sch-icon"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_c_icon = _resolveComponent("c-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.$slots.date)
      ? _renderSlot(_ctx.$slots, "date", {
          key: 0,
          date: _ctx.date
        })
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_c_icon, {
            name: "double-back",
            class: "month-btn year-reduce",
            onClick: _ctx.reduceYear
          }, null, 8, ["onClick"]),
          _createVNode(_component_c_icon, {
            name: "back",
            class: "month-btn month-reduce",
            onClick: _ctx.reduceMonth
          }, null, 8, ["onClick"]),
          (_ctx.month)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.date.getFullYear() + "年" + (_ctx.date.getMonth() + 1) + "月"), 1))
            : _createCommentVNode("", true),
          _createVNode(_component_c_icon, {
            name: "back",
            class: "month-btn month-plus",
            onClick: _ctx.plusMonth
          }, null, 8, ["onClick"]),
          _createVNode(_component_c_icon, {
            name: "double-back",
            class: "month-btn year-plus",
            onClick: _ctx.plusYear
          }, null, 8, ["onClick"])
        ])),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", {
        class: "area",
        style: _normalizeStyle({ height: _ctx.height > 0 ? `${_ctx.height}px` : null })
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["month", { animation: _ctx.moveInfo.animation }]),
          style: _normalizeStyle({ transform: `translateY(${_ctx.moveInfo.y}px)` }),
          onTouchstart: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.moveStart && _ctx.moveStart(...args))),
          onTouchmove: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.moving && _ctx.moving(...args))),
          onTouchend: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.moveEnd && _ctx.moveEnd(...args)))
        }, [
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.months.prev, (m, num) => {
              return (_openBlock(), _createElementBlock("div", {
                key: num,
                class: _normalizeClass(["t-body", [`prev-${num}`]])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(m, (tr, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "tr"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tr, (td, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: i,
                        class: _normalizeClass(["td", {
                    weekend: td.weekday == 0 || td.weekday == 6,
                    enable: td.enable,
                    'out-month': !td.inMonth,
                  }]),
                        onClick: ($event: any) => (_ctx.selectDate(index, i))
                      }, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["date-info", { now: td.isToday, select: _ctx.selected == td.dateStr }])
                        }, [
                          _createElementVNode("div", _hoisted_8, _toDisplayString(td.day), 1),
                          (_ctx.lunar)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(td.lunar.showInLunar), 1))
                            : _createCommentVNode("", true)
                        ], 2),
                        _renderSlot(_ctx.$slots, "default", { date: td })
                      ], 10, _hoisted_7))
                    }), 128))
                  ]))
                }), 128))
              ], 2))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.months.current, (tr, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "tr"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tr, (td, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: i,
                    class: _normalizeClass(["td", td.classes]),
                    onClick: ($event: any) => (_ctx.selectDate(index, i))
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["date-info", { now: td.isToday, select: _ctx.selected == td.dateStr }])
                    }, [
                      _createElementVNode("div", _hoisted_12, _toDisplayString(td.day), 1),
                      (_ctx.lunar)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(td.lunar.showInLunar), 1))
                        : _createCommentVNode("", true)
                    ], 2),
                    _renderSlot(_ctx.$slots, "default", { date: td })
                  ], 10, _hoisted_11))
                }), 128))
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_14, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.months.next, (m, num) => {
              return (_openBlock(), _createElementBlock("div", {
                key: num,
                class: _normalizeClass(["t-body", [`next-${num}`]])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(m, (tr, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "tr"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tr, (td, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: i,
                        class: _normalizeClass(["td", {
                    weekend: td.weekday == 0 || td.weekday == 6,
                    enable: td.enable,
                    'out-month': !td.inMonth,
                  }]),
                        onClick: ($event: any) => (_ctx.selectDate(index, i))
                      }, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["date-info", { now: td.isToday, select: _ctx.selected == td.dateStr }])
                        }, [
                          _createElementVNode("div", _hoisted_16, _toDisplayString(td.day), 1),
                          (_ctx.lunar)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(td.lunar.showInLunar), 1))
                            : _createCommentVNode("", true),
                          (td.sch)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_18))
                            : _createCommentVNode("", true)
                        ], 2),
                        _renderSlot(_ctx.$slots, "default", { date: td })
                      ], 10, _hoisted_15))
                    }), 128))
                  ]))
                }), 128))
              ], 2))
            }), 128))
          ])
        ], 38)
      ], 4)
    ])
  ]))
}